export default __webpack_public_path__ + "static/logo-tishman-speyer-6fe6820a20b337609c073bce6ae111ce.png";